<div class="popup">
    <div class="popup-header">
        <div class="header-left">
            <div class="header-icon">
                <img src="../../../../../assets/icones/quotations.svg" alt="">
            </div>
            <h1 class="header-title">{{ 'quotations_and_orders.copilot_score.score_details.title' | translate }} {{data.quote_name}} </h1>
        </div>
        <button class="close-btn" (click)="close()">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 6L6 18M6 6L18 18" stroke="#232529" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </button>
    </div>

    <div class="score">
        <div class="score-header">
            <div class="score-header-left gray-text">
                {{ 'quotations_and_orders.copilot_score.score_details.client_score' | translate }}
            </div>
            <div class="score-header-right">
                <span class="blue-text">{{data.score.score_client | number:'1.2-2'}} <span class="gray-text">/ 100</span></span>
            </div>
        </div>
        <div class="list-score">
           <ul>
            <li *ngFor="let item of data.score.summary_client">
                {{item}}
            </li>
           </ul>
        </div>
    </div>

    <div class="score">
        <div class="score-header">
            <div class="score-header-left gray-text">
                {{ 'quotations_and_orders.copilot_score.score_details.rfq_score' | translate }}
            </div>
            <div class="score-header-right">
                <span class="blue-text">{{data.score.score_RFQ | number:'1.2-2'}} <span class="gray-text">/ 100</span></span>
            </div>
        </div>
        <div class="list-score">
            <ul>
                <li *ngFor="let item of data.score.summary_rfq">
                    {{item}}
                </li>
            </ul>
        </div>
    </div>

    <div class="score">
        <div class="score-header">
            <div class="score-header-left gray-text">
                {{ 'quotations_and_orders.copilot_score.score_details.date_score' | translate }}
            </div>
            <div class="score-header-right">
                <span class="blue-text">{{data.score.score_date | number:'1.2-2'}} <span class="gray-text">/ 100</span></span>
            </div>
        </div>
    </div>

    <hr class="details-divider"/>

    <div class="score">
        <div class="score-header">
            <div class="score-header-left main-text">
                {{ 'quotations_and_orders.copilot_score.score_details.overall_score' | translate }}
            </div>
            <div class="score-header-right">
                <span class="blue-text">{{data.overall_score | number:'1.2-2'}} <span class="gray-text">/ 100</span></span>
            </div>
        </div>
    </div>

    <div class="button-group">
        <button class="btn btn-update" (click)="close()">{{ 'common.close' | translate }}</button>
    </div>
</div>